module.exports = __webpack_public_path__ + "img/ge.2c8b9790.svg";